import { createAction } from '@/utils/actions'
import * as routesActionTypes from './constants'

export const updateRoute = createAction(routesActionTypes.UPDATE_ROUTE)
export const previousPage = createAction(routesActionTypes.PREVIOUS_PAGE)
export const nextPage = createAction(routesActionTypes.NEXT_PAGE)
export const setPage = createAction(routesActionTypes.SET_PAGE)
